import React, { Children, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { SFIcon } from 'components/core/SFIcon';
import { Button } from 'components/core/Button';
import DotControl from './DotControl';

import './carousel.scss';

export function Carousel({
	children = [],
	slideShowing: initialSlideShowing = 0,
	className,
}) {
	const [slideShowing, setSlideShowing] = useState(initialSlideShowing);
	const handleNext = useCallback(() => {
		setSlideShowing((prev) => {
			if (prev + 1 < children.length) {
				return prev + 1;
			}
			return 0;
		});
	}, [children.length]);
	const handlePrevious = useCallback(() => {
		setSlideShowing((prev) => {
			if (prev - 1 >= 0) {
				return prev - 1;
			}
			return children.length - 1;
		});
	}, [children.length]);
	const handleSlideDot = useCallback((dotIndex) => {
		setSlideShowing(dotIndex);
	}, []);
	return (
		<div className={classnames('ph-carousel', className)}>
			{Children.toArray(children).length > 1 && (
				<div className="controls-overlay">
					<Button
						onClick={handlePrevious}
						className="control-button control-left"
						primary={false}
					>
						<SFIcon
							className="control-arrow"
							icon="chevron-left"
						/>
					</Button>
					<Button
						onClick={handleNext}
						className="control-button control-right"
						primary={false}
					>
						<SFIcon
							className="control-arrow"
							icon="chevron-right"
						/>
					</Button>
					<ul className="image-dots">
						{Children.toArray(children).map((slide, index) => (
							<DotControl
								key={slide.key}
								index={index}
								onClick={handleSlideDot}
								slideShowing={slideShowing === index}
							/>
						))}
					</ul>
				</div>
			)}
			<div className="carousel-window">
				{Children.toArray(children).map((slide, index) => (
					<div
						key={slide.key}
						className={classnames('carousel-content', {
							selected: index === slideShowing,
						})}
					>
						{slide}
					</div>
				))}
			</div>
		</div>
	);
}

Carousel.propTypes = {
	/** Additional class name to be applied to the component */
	className: PropTypes.string,
	children: PropTypes.node,
	slideShowing: PropTypes.number,
};

export default Carousel;
